module.exports = __webpack_public_path__ + "img/Icon120-narrow.ac628cfb.png";